import { mobileApiRequest, workspaceActionsRequest } from '../../apiRequests'

/**
 * Get account members (colleagues)
 * This returns all users in the current account
 */
export const getAccountMembers = async () => {
    const action = {
        action: 'listUserColleagues',
    }
    const response = await workspaceActionsRequest(action)
    if (response?.status === 'success') {
        return response.body
    }
    return []
}

export const getUsersFromWorkspace = async (workspaceID) => {
    const action = {
        action: 'readWorkspaceUsers',
        workspaceID,
        skipWorkspaceIDOverride: true,
    }
    const response = await workspaceActionsRequest(action)
    if (response?.status === 'success') {
        return response.body
    }
    return []
}

/**
 * Add user to workspace
 * @param {string} userID - User ID to add
 * @param {string} workspaceID - Workspace ID
 * @param {string} role - Workspace role (Owner, Admin, Member)
 */
export const addUserToWorkspace = async (workspaceID, userID, role) => {
    const action = {
        action: 'addUserToWorkspace',
        userID,
        workspaceID,
        skipUserIDOverride: true,
        skipWorkspaceIDOverride: true,
        role,
    }
    const response = await mobileApiRequest(action)
    if (response?.messages) {
        return response
    }
    throw new Error(response?.error || 'Failed to add user to workspace')
}

/**
 * Remove user from workspace
 * @param {string} userID - User ID to remove
 * @param {string} workspaceID - Workspace ID
 */
export const removeUserFromWorkspace = async (workspaceID, userID) => {
    const action = {
        action: 'removeUserFromWorkspace',
        userID,
        workspaceID,
        skipUserIDOverride: true,
        skipWorkspaceIDOverride: true,
    }
    const response = await mobileApiRequest(action)
    if (response?.messages) {
        return response
    }
    throw new Error(response?.error || 'Failed to remove user from workspace')
}

/**
 * Bulk assign workspaces to a user
 * @param {string} userID - User ID
 * @param {Array<string>} workspaceIDs - Array of workspace IDs
 * @param {string} role - Workspace role to assign (Owner, Admin, Member)
 */
export const bulkAssignWorkspaces = async (userID, workspaceIDs, role) => {
    const action = {
        action: 'bulkAssignWorkspaces',
        userID,
        workspaceIDs,
        skipUserIDOverride: true,
        skipWorkspaceIDOverride: true,
        role,
    }
    const response = await mobileApiRequest(action)
    if (response?.messages) {
        return response
    }
    throw new Error(response?.error || 'Failed to bulk assign workspaces')
}

export const getWorkspaceData = async (workspaceID) => {
    const action = {
        action: 'getObjects',
        class: 'scoop.workspace.Workspace',
        attributeName: 'workspaceID',
        attributeValue: workspaceID,
        skipWorkspaceIDOverride: true,
        isDev: process.env.REACT_APP_SCOOP_ENV === 'dev',
    }
    const result = await mobileApiRequest(action)
    return result.objects[0]
}

export const updateWorkspaceWeekStartDay = async (workspaceData, weekStartDay) => {
    if (!workspaceData) return

    const action = {
        action: 'putObject',
        class: 'scoop.workspace.Workspace',
        value: {
            ...workspaceData,
            weekStartDay,
        },
        skipWorkspaceIDOverride: true,
    }

    return await mobileApiRequest(action)
}
